export const ALL_COLORS = {
  palette1: ['#f79256', '#fbd1a2', '#7dcfb6', '#00b2ca', '#1d4e89'],

  palette2: ['#033f63', '#28666e', '#7c9885', '#b5b682', '#fedc97'],

  palette3: ['#5B93B6', '#A0C4DB', '#4C6973', '#8DA5B3', '#BEC7D5', '#A39BB4', '#6C757D', '#D1E0E0'],

  palette4: ['#7EADA9', '#AA9273', '#1F5560', '#45302A', '#111823'],

  palette5: ['#874537', '#D37F7F', '#F2E1C3', '#54A498', '#105446'],
};

export const FLAT_ALL_COLORS = [
    '#874537', '#D37F7F', '#5B93B6', '#54A498', '#105446',
    '#7EADA9', '#AA9273', '#1F5560', '#45302A', '#1F5560',
  '#f79256', '#fbd1a2', '#7dcfb6', '#00b2ca', '#1d4e89',
  '#033f63', '#28666e', '#7c9885', '#b5b682', '#fedc97',
  '#F2E1C3', '#A0C4DB', '#4C6973', '#8DA5B3', '#BEC7D5', '#A39BB4', '#6C757D', '#D1E0E0',
];

export const VIBRANT_COLORS = ['#f79256', '#033f63', '#7dcfb6', '#00b2ca', '#1d4e89'];
export const EARTH_TONE_COLORS = ['#D37F7F', '#28666e', '#7c9885', '#b5b682', '#fedc97'];
export const CALM_BLUE_COLORS = ['#5B93B6', '#AA9273', '#4C6973', '#8DA5B3', '#b5b682', '#874537'];
export const DEEP_NEUTRAL_COLORS = ['#7EADA9', '#fedc97', '#45302A','#1F5560','#874537'];
export const WARM_COOL_COLORS = ['#874537', '#D37F7F', '#F2E1C3', '#54A498', '#105446'];

// Chart specific colors - using palette colors
export const LOCATION_COLORS = VIBRANT_COLORS;
export const CATEGORY_COLORS = EARTH_TONE_COLORS;
export const CONTAINMENT_COLORS = CALM_BLUE_COLORS;
export const ROOT_CAUSE_COLORS = DEEP_NEUTRAL_COLORS;
export const MONTHLY_CHART_COLORS = FLAT_ALL_COLORS;
